import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../Utils/apiClient";
import { resetStore } from "./resetStore";

const getError = (error, fallback) =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  error?.message ||
  fallback;

export const fetchSurveySettings = createAsyncThunk(
  "surveySettings/fetch",
  async (uid, { rejectWithValue }) => {
    try {
      if (!uid) throw new Error("UID не передан");

      const response = await apiRequest(
        "GET",
        `/surveySettings/${encodeURIComponent(uid)}`
      );

      const data = response?.data || response;
      return data?.settings || {};
    } catch (error) {
      return rejectWithValue(getError(error, "Не удалось загрузить настройки анкеты"));
    }
  }
);

export const saveSurveySettings = createAsyncThunk(
  "surveySettings/save",
  async ({ uid, settings }, { rejectWithValue }) => {
    try {
      if (!uid) throw new Error("UID не передан");

      const response = await apiRequest(
        "PUT",
        `/surveySettings/${encodeURIComponent(uid)}`,
        { settings }
      );

      const data = response?.data || response;
      return data?.settings || {};
    } catch (error) {
      return rejectWithValue(getError(error, "Не удалось сохранить настройки анкеты"));
    }
  }
);

const initialState = {
  settings: {},
  status: "idle",
  error: null,
};

const surveySettingsSlice = createSlice({
  name: "surveySettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSurveySettings.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSurveySettings.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.settings = action.payload || {};
      })
      .addCase(fetchSurveySettings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error?.message || null;
      })
      .addCase(saveSurveySettings.pending, (state) => {
        state.status = "saving";
        state.error = null;
      })
      .addCase(saveSurveySettings.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.settings = action.payload || {};
      })
      .addCase(saveSurveySettings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error?.message || null;
      })
      .addCase(resetStore, () => initialState);
  },
});

export default surveySettingsSlice.reducer;
